<template>
  <div class="container">
    <a-modal
      :title="audit ? '项目中止审批' : '项目中止详情'"
      class="gufiiguy"
      :visible="flowPathVisible"
      width="60%"
      @cancel="flowPathVisible = false"
      :maskClosable="false"
    >
      <div class="container-box">
        <div class="container-top">
          <div class="left">
            <div style="margin-top: 10px">
              <span style="font-weight: 700; color: black; font-size: 24px">{{ detailData.title }}</span>
            </div>
            <div class="lineBox">
              <div style="width: 50%; margin-top: 10px">申请人：{{ detailData.applier }}</div>
              <div style="width: 50%; margin-top: 10px">申请时间：{{ detailData.createTime }}</div>
            </div>
            <div class="lineBox">
              <div style="width: 50%; margin-top: 10px">申请编号：{{ detailData.applyCode }}</div>
            </div>
            <!-- <div class="lineBox">
                            <div style="width: 50%; margin-top: 10px" >抄送人：{{ detailData.ccName }}</div>
                        </div> -->
          </div>
          <div class="right">
            <!-- v-if="this.detailData.result == 3" -->
            <!-- 驳回 -->
            <img v-if="detailData.result == 3" src="../../../../public/images/reject.png" />
            <!-- 通过 -->
            <img v-if="detailData.result == 2" src="../../../../public/images/pass.png" />
            <!-- 审批中 -->
            <img v-if="detailData.result == 1" src="../../../../public/images/examine.png" />
            <!-- 撤销 -->
            <img v-if="detailData.result == 4" src="../../../../public/images/stop.png" />
          </div>
        </div>
        <div class="container-bottom">
          <div class="container-left">
            <div style="font-size: 20px; margin: 5px 0; color: #aaa">项目信息</div>
            <!-- <div class="container-left-item4"> -->
              <div class="container-left-item1">项目id：{{ detailData.projectId }}</div>
              <div class="container-left-item1">项目编号：{{ detailData.identifier }}</div>
            <!-- </div> -->
            <!-- <div class="container-left-item4"> -->
              <div class="container-left-item1">受检单位：{{ detailData.company }}</div>
              <div class="container-left-item1">项目状态：{{ detailData.status }}</div>
            <!-- </div> -->
            <!-- <div class="container-left-item4"> -->
              <div class="container-left-item1">业务员：{{ detailData.salerman }}</div>
              <div class="container-left-item1">项目金额：{{ detailData.amount }}</div>
            <!-- </div> -->
            <!-- <div class="container-left-item4"> -->
              <div class="container-left-item1">已收款金额：{{ detailData.returnAmount }}</div>
              <div class="container-left-item1">已开票金额：{{ detailData.billAmount }}</div>
            <!-- </div> -->
          </div>
          <div class="container-right">
            <div style="font-size: 20px; margin: 5px 0">审批信息</div>
            <flowPath ref="flowPath" v-if="flowPathVisible"></flowPath>
          </div>
        </div>
      </div>
      <template slot="footer">
        <!-- <a-button type="primary" @click="downloadFile" style="float: left" > 导出 </a-button> -->
        <a-button key="back" @click="flowPathVisible = false"> 取消 </a-button>
        <a-button type="danger" @click="reject(3)" v-if="audit"> 驳回 </a-button>
        <a-button key="submit" type="primary" @click="reject(1)" v-if="audit"> 转交 </a-button>
        <a-button key="submit" type="primary" @click="reject(2)" v-if="audit"> 通过 </a-button>
      </template>
    </a-modal>
    <a-modal
      v-model="is_revocation"
      :title="result == 3 ? '确认驳回此申请吗?' : '确认通过此申请吗?'"
      on-ok="handleOkReason"
    >
      <template slot="footer">
        <a-button key="back" @click="is_revocation = false"> 取消 </a-button>
        <a-button key="submit" type="primary" :loading="loading" @click="handleOkReason" v-if="result == 3">
          驳回
        </a-button>
        <a-button key="submit" type="primary" :loading="loading" @click="handleOkReason" v-if="result == 2">
          通过
        </a-button>
      </template>
      <a-textarea placeholder="请输入原因" v-model="comment" />
    </a-modal>
    <transferModal ref="transferModal" @sure="handleSure" />
  </div>
</template>

<script>
import { downLoadWordPost } from '@/utils/index'
import flowPath from '@/views/activiti/modules/flowPath.vue'
import transferModal from '@/views/activiti/modules/TransferModal.vue'
import { act_task_audit, payment_apply_downlodPdf, modalMap, contractReview, get_process_all } from '@/api/activiti'
import { terminationDetail } from '@/api/budget'
const exportBaseUrl = process.env.VUE_APP_EXPORT_BASE_URL
export default {
  components: {
    flowPath,
    transferModal,
  },
  props: {
    audit: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      is_revocation: false,
      flowPathVisible: false,
      detailData: {},
      record: {},
      statusList: {
        1: '项目录入',
        2: '任务分配',
        5: '采样',
        10: '收样',
        20: '检测报告',
        30: '报告装订',
        40: '质控签发',
        50: '报告寄送',
        60: '项目归档',
        70: '项目结束',
        98: '任务挂起',
        99: '项目中止',
      },
    }
  },
  methods: {
    show(data) {
      console.log(data, 'data===================')
      this.record = data
      terminationDetail({
        tableId: data.tableId,
      }).then((res) => {
        if (res.code == 200) {
          Object.assign(res.data, {
            result: data.result,
          })
          this.detailData = res.data
          this.flowPathVisible = true
          this.$nextTick(() => {
            this.$refs.flowPath.init({
              procInstId: data.procInstId,
              procDefKey: data.procDefKey,
            })
          })
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    download() {
      payment_apply_downlodPdf({
        businessKey: this.record.businessKey,
      }).then((res) => {
        window.open(exportBaseUrl + '/file/download?path=' + res.data)
      })
    },
    //驳回
    reject(result_) {
      if (result_ == 1) {
        this.$refs.transferModal.show({
          record: this.record,
        })
      } else {
        this.is_revocation = true
        this.comment = ''
        this.result = result_
      }
    },
    handleOkReason() {
      if (this.result == 3) {
        if (this.comment == '') {
          this.$message.error('请输入驳回意见！')
        } else {
          clearTimeout(this.timeout)
          console.log(this.timeout, 'this.timeout==========================')
          this.timeout = setTimeout(() => {
            //通过审批
            this.actTask()
          }, 1000)
          // this.actTask()
        }
      } else if (this.result == 2) {
        clearTimeout(this.timeout)
        console.log(this.timeout, 'this.timeout==========================')
        this.timeout = setTimeout(() => {
          //通过审批
          this.actTask()
        }, 1000)
      }
    },
    actTask() {
      act_task_audit({
        taskId: this.record.id,
        procDefKey: this.record.processDefKey,
        procInstId: this.record.procInstId,
        procName: this.record.processName,
        applyer: this.record.applyer,
        result: this.result,
        businessKey: this.record.businessKey,
        comment: this.comment,
        taskDefKey: this.record.taskDefKey,
      }).then((res) => {
        if (res.code != 200) {
          this.$message.error(res.msg)
          return
        }
        this.$message.success('审批成功')
        this.$emit('ok')
        this.flowPathVisible = false
        this.is_revocation = false
      })
    },
    // 导出
    downloadFile() {
      get_process_all({
        procInstId: this.record.procInstId,
        name: this.record.procDefKey,
        userId: this.$store.getters.userId,
      }).then((res) => {
        if (res.code == 200) {
          var informationData = res.data
          Object.assign(informationData, {
            processData: this.detailData,
          })
          downLoadWordPost('/external/oa_non_a/docx_generate/approval', informationData)
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    handleSure() {
      this.flowPathVisible = false
      this.$emit('ok')
    },
  },
}
</script>

<style lang="less" scoped>
.container-box {
  padding: 10px;
  .container-top {
    width: 100%;
    padding-bottom: 10px;
    border-bottom: 1px solid #ccc;
    display: flex;
    justify-content: space-between;
    .left {
      width: 65%;
      // background-color: rgb(213, 116, 116);
    }
    .right {
      width: 20%;
      // background-color: rgb(116, 184, 213);
      margin-left: 10px;
      img {
        // height: 100%;
        width: 70%;
        // object-fit: cover;
        cursor: pointer;
      }
    }
  }
  .container-bottom {
    display: flex;
    height: 100%;
    justify-content: space-between;
    color: rgb(17, 17, 17);
    .container-left {
      width: 58%;
      height: 100%;
      padding: 20px;
      border-right: 1px solid #ccc;
      // background-color: rgb(213, 116, 116);
      .container-left-item {
        display: flex;
        padding: 3px 0;
        font-size: 16px;
        span {
          width: 33%;
        }
      }
      .container-left-item1 {
        font-size: 16px;
        padding: 4px 0;
        span {
          width: 100%;
        }
      }
      .container-left-item2 {
        padding-top: 10px;
      }
      .container-left-item3 {
        display: flex;
        padding: 3px 0;
        font-size: 16px;
        span:nth-child(1) {
          width: 66%;
        }
      }
      .container-left-item4 {
        display: flex;
        padding: 3px 0;
        font-size: 16px;
        span {
          width: 50%;
        }
      }
      .container-left-item5 {
        display: flex;
        padding: 3px 0;
        font-size: 16px;
        span {
          width: 25%;
        }
      }
    }
    // .container-left::after {
    //   content: '';
    //   height: 100%;
    //   width: 1px;
    //   background-color: black;
    //   position: absolute;
    //   left: -10px;
    // }
    .container-right {
      width: 40%;
      height: 100%;
      padding-top: 10px;
      // background-color: rgb(116, 184, 213);
    }
  }
}
</style>